import Link from 'next/link';
import { useState } from 'react';
import Popup from 'reactjs-popup'
import { CartType } from '../../../../types/CartType';
import styles from './FloatingCartPopUp.module.scss'

type FloatingCartPopUpProps = {
  cart: CartType
}

export default function ListHotelPopUp({cart} : FloatingCartPopUpProps) {

  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);

  return (
    <div>
      <button type='button' onClick={() => setOpen(o => !o)}>
        <span className={styles.visuallyHidden}>Number of items in cart:</span>
        {cart.meta.total_count}
      </button>
      <Popup modal open={open} onClose={closeModal} contentStyle={{borderRadius: '10px', width: '30%'}}>
        {(close: Function) => (
          <div className={styles.modal}>
            <p>You have selected fewer rooms than you have searched for. Would you like to proceed?</p>
            <Link href='/shopping-cart'>
              {/* @next-codemod-error This Link previously used the now removed `legacyBehavior` prop, and has a child that might not be an anchor. The codemod bailed out of lifting the child props to the Link. Check that the child component does not render an anchor, and potentially move the props manually to Link. */
              }
              <button aria-label='go to cart' className={styles.btn}>Go To Cart</button>
            </Link>
          </div>
        )}
      </Popup>
    </div>
  );
}